var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require("@/assets/images/dashboard/workbench.svg")}}),_c('p',{staticClass:"empty__desc"},[_vm._v(_vm._s(_vm.$t('common.empty')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }